<template>
  <div>
    Error Not Found
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  },

  mounted () {
    console.log(this.$route)
  }

}
</script>



// WEBPACK FOOTER //
// src/components/Error.vue